"use client";
import React, { useState, useEffect } from "react";

import { CaretUpOutlined } from "@ant-design/icons";
const ScrollToTopButton = () => {
	const [isVisible, setIsVisible] = useState(false);

	// 监听滚动事件
	useEffect(() => {
		const toggleVisibility = () => {
			if (window.scrollY > 300) {
				setIsVisible(true);
			} else {
				setIsVisible(false);
			}
		};

		window.addEventListener("scroll", toggleVisibility);

		return () => {
			window.removeEventListener("scroll", toggleVisibility);
		};
	}, []);

	// 平滑滚动到顶部
	const scrollToTop = () => {
		window.scrollTo({
			top: 0,
			behavior: "smooth",
		});
	};

	return (
		<div>
			{isVisible && (
				<button
					onClick={scrollToTop}
					className="group fixed bottom-[150px] right-8 h-12 w-12 cursor-pointer rounded-full bg-white p-3 text-black shadow-xl transition-all duration-300"
					aria-label="Scroll to top"
				>
					<CaretUpOutlined className="transform transition-all group-hover:-translate-y-1" />
				</button>
			)}
		</div>
	);
};

export default ScrollToTopButton;
